import { Components, Theme } from '@mui/material';

export const MuiDialogTitle = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(2, 3),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      color: theme.palette.neutral.onSurface,
      '& .MuiIconButton-root': {
        right: theme.spacing(-1),
        color: theme.palette.neutral.onSurfaceVariant
      }
    }),
  },
} as Components<Theme>['MuiDialogTitle'];

export const MuiDialogActions = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(2, 3)
    }),
  },
} as Components<Theme>['MuiDialogActions'];